import type { RnAiAudioDetail } from "../../stores/ai-gentools-store";

function readString(row: Record<string, unknown>, ...keys: string[]): string {
    for (const key of keys) {
        const value = row[key];
        if (value === null || value === undefined) continue;
        const text = String(value).trim();
        if (text) return text;
    }
    return "";
}

export function normalizeRnAiAudio(row: unknown): RnAiAudioDetail | null {
    if (!row || typeof row !== "object") return null;
    const r = row as Record<string, unknown>;
    const state = readString(r, "state");
    if (!state) return null;

    return {
        state,
        title: readString(r, "title") || "Campaign audio",
        description: readString(r, "description"),
        audio_path: readString(r, "audio_path", "audioPath"),
        audio_description_path: readString(
            r,
            "audio_description_path",
            "audioDescriptionPath",
            "audio_description",
            "audioDescription"
        ),
        AI_image: readString(r, "AI_image", "ai_image") || undefined,
        ai_image: readString(r, "ai_image", "AI_image") || undefined,
    };
}

export function getAudioDescriptionPath(item: RnAiAudioDetail): string {
    return item.audio_description_path?.trim() ?? "";
}

export function isAudioFilePath(path: string): boolean {
    return /\.(mp3|m4a|wav|ogg|aac)(\?|$)/i.test(path) || path.includes("/");
}
